import { Footer } from "@nju/feature-portal-footer";
import { Header } from "@nju/feature-portal-header";
import { WWTPage } from "@nju/feature-portal-wwt";
import { BlockContent, LayoutWrapper } from "@nju/ui";
import { ClientSideOnly } from "../../components/ClientSideRenderer";

export default function Wwt() {
  return (
    <LayoutWrapper>
      <Header />
      <BlockContent grid="narrow" spacing="xl">
        <ClientSideOnly>
          <WWTPage />
        </ClientSideOnly>
      </BlockContent>
      <Footer />
    </LayoutWrapper>
  );
}
